import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '../../../hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import { MEMBERTYPEE } from '../../../api';
import { normalizeBizTableColumns } from '@/utils/tableColumns';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();
const storeOptions = ref<{ label: string; value: number }[]>([]);

const addInitValue = {
  memberType: MEMBERTYPEE.Normal,
};

const conditionsInitValue = {
};

const memberTypeOptions = [
  { label: '会员', value: MEMBERTYPEE.Normal },
  { label: '黑名单', value: MEMBERTYPEE.Black },
  { label: '白名单', value: MEMBERTYPEE.White },
];

// 创建列定义
const createColumns = (storeOptionsList = []) => normalizeBizTableColumns([
  {
    name: 'storeId',
    label: '所属门店',
    type: 'searchSelect',
    isCondition: true,
    rule: [{ required: true, message: '请选择所属门店' }],
    width: 150,
    options: storeOptionsList,
  },
  {
    name: 'name',
    label: '会员姓名',
    type: 'string',
    isCondition: true,
    rule: [{ required: true, message: '请输入会员姓名' }],
    width: 120,
  },
  {
    name: 'phoneNumber',
    label: '手机号码',
    type: 'string',
    isCondition: true,
    rule: [
      { required: true, message: '请输入手机号码' },
      { pattern: /^1[3-9]\d{9}$/u, message: '请输入正确的手机号码' },
    ],
    width: 120,
  },
  {
    name: 'memberType',
    label: '会员类型',
    type: 'select',
    isCondition: true,
    rule: [{ required: true, message: '请选择会员类型' }],
    width: 120,
    options: memberTypeOptions,
  },
  {
    name: 'createTime',
    label: '创建时间',
    type: 'string',
    hideEdit: true,
    hideCreate: true,
    width: 160,
  },
]);

// 获取门店选项
const fetchStoreOptions = async() => {
  try {
    const res = await useApi().storeApi.listStorestore({
      conditions: {},
    });

    console.log(res);

    // 格式化门店选项
    return res.data?.data?.map((store: any) => ({
      label: `${store.name || '未知'}`,
      value: store.id,
    })) || [];
  } catch (error) {
    console.error('获取门店列表失败:', error);
    ElMessage.error('获取门店列表失败');
    return [];
  }
};

// 初始化
const init = useBaseAsync(async() => {
  // 获取门店列表
  const storeOptionsList = await fetchStoreOptions();

  // 使用更强的类型断言完全绕过类型系统
  columns.value = createColumns(storeOptionsList) as unknown as HpsfirProTableColumn[];
});

const operates: any[] = [];

const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().memberApi.pageMembermember({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }

        conditions[key] = val;
        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您确定要删除会员"${row.name || '未命名'}"吗？此操作不可恢复，请谨慎操作。`;

const addFun = useBaseAsync(async(data: any) => {
  await useApi().memberApi.addMembermember({
    memberAdminVo: {
      ...data,
    },
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().memberApi.updateMembermember({
    memberAdminVo: {
      ...data,
    },
  });
  ElMessage.success('修改成功');
});

const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().memberApi.delMembermember(data.id);
  ElMessage.success('删除成功');
});

// 页面初始化时获取门店列表和初始化表格
Promise.all([init()]);

return (_ctx: any,_cache: any) => {
  const _component_HpsfirProTable = _resolveComponent("HpsfirProTable")!

  return (_openBlock(), _createBlock(_component_HpsfirProTable, {
    ref_key: "tableRef",
    ref: tableRef,
    "export-file-name": "会员管理",
    title: "会员管理",
    paginations: { pageSize: 10 },
    columns: columns.value,
    "get-data": _unref(getData),
    "on-add": _unref(addFun),
    "on-delete": _unref(deleteFun),
    "on-edit": _unref(updateFun),
    loading: loading.value,
    "is-dangder-delete": true,
    "format-dangder-delete-info": formatDeleteInfo,
    "row-key": "id",
    operates: operates,
    "add-init-values": addInitValue,
    "codition-init-values": conditionsInitValue
  }, null, 8, ["columns", "get-data", "on-add", "on-delete", "on-edit", "loading"]))
}
}

})